module.exports = __webpack_public_path__ + "media/images/lb/408-2bfb86334dda02cb4743ec4ffc8a70c5.svg";